import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getIsProjectCompleted } from "~/store/selectors/selector.projects.jsx";
import { getOpenSubtasksCountByTaskId } from "~/store/selectors/selector.subtasks.jsx";
import {
  makeGetIsTaskCompletedByIdSelector,
  makeGetOpenParentDependenciesCountByIdSelector,
} from "~/store/selectors/selector.tasks.jsx";
import { hasLoggedUserElevatedPermissions } from "~/store/selectors/selector.users.jsx";
import TaskCompleteCheckbox from "./TaskCompleteCheckbox.jsx";

const TaskCompleteCheckboxContainer = ({ projectId, taskId, className, cardMode, isDependency }) => {
  const getOpenParentDependenciesCountById = useMemo(makeGetOpenParentDependenciesCountByIdSelector, []);
  const getIsTaskCompletedById = useMemo(makeGetIsTaskCompletedByIdSelector, []);
  const defaultCompleted = useSelector((state) => getIsTaskCompletedById(state, taskId));
  const parentDependenciesCount = useSelector((state) => getOpenParentDependenciesCountById(state, taskId));
  const openSubtasksCount = useSelector((state) => getOpenSubtasksCountByTaskId(state, taskId));
  const isVisible = useSelector(hasLoggedUserElevatedPermissions);
  const disabled = useSelector((state) => getIsProjectCompleted(state, projectId));

  if (!isVisible || isDependency || cardMode) return null;

  return (
    <TaskCompleteCheckbox
      taskId={taskId}
      defaultCompleted={defaultCompleted}
      disabled={disabled}
      className={className}
      parentDependenciesCount={parentDependenciesCount}
      openSubtasksCount={openSubtasksCount}
    />
  );
};

TaskCompleteCheckboxContainer.propTypes = {
  taskId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  projectId: PropTypes.number.isRequired,
  className: PropTypes.string,
  cardMode: PropTypes.bool,
  isDependency: PropTypes.bool,
};

TaskCompleteCheckboxContainer.defaultProps = {
  defaultCompleted: false,
  disabled: false,
  cardMode: false,
  isDependency: false,
};

TaskCompleteCheckboxContainer.displayName = `TaskCompleteCheckbox`;

export default TaskCompleteCheckboxContainer;
